import {Injectable} from '@angular/core';
import {OfflineVoipPeerApiService} from '../../../../services/api/network/offline/voip-peer/offline-voip-peer-api.service';
import {OfflinePeerConnectionApiService} from '../../../../services/api/network/offline/peer-connection/offline-peer-connection-api.service';
import * as _ from 'lodash';
import {MatDialog} from '@angular/material/dialog';
import {CacProfilesApiService} from '../../../../services/api/routing/cac-profiles/cac-profiles-api.service';
import {ConfirmationDialogComponent} from '../../../../dialogs/confirmation-dialog/confirmation-dialog.component';
import {SnackBarService} from '../../../../services/common/snack-bar/snack-bar.service';
import {OfflineMapService} from '../../map/offline-map/offline-map.service';
import {OfflineVoipPeersDialogComponent} from '../../../offline-map/dialogs/offline-voip-peers-dialog/offline-voip-peers-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class OfflineVoipPeerService {

  constructor(private dialog: MatDialog,
              private snackBarService: SnackBarService,
              private offlineMapService: OfflineMapService,
              private cacProfilesApiService: CacProfilesApiService,
              private offlinePconApiService: OfflinePeerConnectionApiService,
              private offlineVoipPeerApiService: OfflineVoipPeerApiService) {
  }

  public addVoipPeer(voipPeer): void {
    const dialogRef = this.dialog.open(OfflineVoipPeersDialogComponent, {
      data: {
        isEditMode: false,
        selectedItem: _.cloneDeep(voipPeer)
      }
    });

    dialogRef.componentInstance.onApply.subscribe(result => {
      this.offlineVoipPeerApiService.addVoipPeer(result.selectedItem).then(() => {
        dialogRef.close();
        this.refreshDiagram();
        this.offlineMapService.removeDraggedSvg();
      }).catch(() => {
        this.offlineMapService.removeDraggedSvg();
      });
    });

    dialogRef.componentInstance.onCancel.subscribe(() => {
      this.offlineMapService.removeDraggedSvg();
    });
  }

  public editVoipPeer(id: number): void {
    this.offlineVoipPeerApiService.getVoipPeerForMap(id).then((voipPeer) => {
      const dialogRef = this.dialog.open(OfflineVoipPeersDialogComponent, {
        data: {
          isEditMode: true,
          selectedItem: _.cloneDeep(voipPeer)
        }
      });

      dialogRef.componentInstance.onApply.subscribe(result => {
        this.offlineVoipPeerApiService.editVoipPeer(result.selectedItem, id).then(() => {
          dialogRef.close();
          this.refreshDiagram();
        }).catch(() => {});
      });

      dialogRef.componentInstance.onCancel.subscribe(() => {
        dialogRef.close();
      });
    });
  }

  public deleteVoipPeer(voipPeer): void {
    const confirmationMessage = `Are you sure you want to delete the VoIP peer: "${voipPeer.name}" ?`;

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: confirmationMessage
      }
    });

    dialogRef.componentInstance.onApply.subscribe(() => {
      this.offlineVoipPeerApiService.deleteVoipPeer(voipPeer.id).then(() => {
        dialogRef.close();
        this.snackBarService.display(`${voipPeer.name} successfully deleted`);
        this.refreshDiagram();
      });
    });

    dialogRef.componentInstance.onCancel.subscribe(() => {
      /* this.sharedEventService.broadcast('openConfirmationDialogWindow',
           `Are you sure you want to delete this VoIP Peer: "${voipPeer.name}" ?`, 'Delete', () => {
         this.offlineVoipPeerApiService.deleteVoipPeer(voipPeer.id)
           .then(() => {
             this.sharedEventService.broadcast('closeConfirmationDialogWindow');
             this.refreshDiagram();
           }).catch(() => {
           this.sharedEventService.broadcast('closeConfirmationDialogWindow');
         });
       });*/
    });
  }

  private refreshDiagram(): void {
    this.offlineMapService.refresh();
  }

  private editOfflineVoipPeerInServer(voipPeer, id: number): void {
    this.offlineVoipPeerApiService.editVoipPeer(voipPeer, id).then(() => {
      // this.sharedEventService.broadcast('closeOfflineVoipPeerDialog');
      this.refreshDiagram();
    }).catch(() => {});
  }
}
